var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M985.598 343.436c0-56.565-39.968-125.289-89.495-153.624L601.497 21.23c-49.428-28.278-129.465-28.335-178.992 0L127.893 189.806c-49.417 28.283-89.49 96.954-89.49 153.63v337.131c0 56.565 39.968 125.289 89.495 153.63l294.606 168.571c49.433 28.283 129.47 28.335 178.997 0l294.601-168.571c49.422-28.283 89.495-96.954 89.495-153.624V343.431z"
  })));
}
export default SvgHexagon;